import WebLayout from './Web/AssignmentsFieldLayoutWeb';
import MobileLayout from './Mobile/AssignmentsFieldLayout.mobile'
import { isReactNative } from 'ui-builder';

export * from './types';

export default isReactNative() ? MobileLayout : WebLayout;
